import { ImageMetadataTags } from './image-metadata-tags';
import { SchemaMarkupScript } from './schema-markup-script';
import { HeadMetadata } from '@exploration/shared-types';
import Head from 'next/head';

// --------------------------------------------------------------------------

export const HeadWithMetadata = ({ metadata }: { metadata: HeadMetadata }) => {
  const {
    title,
    description,
    keywords,
    image,
    url,
    titleTrailer = ' | Thrivent',
    siteName = 'Thrivent.com',
  } = metadata || {};

  return (
    <Head>
      {(!!title || !!titleTrailer) && (
        <title key="title">{title + titleTrailer}</title>
      )}

      {!!description && (
        <meta name="description" content={description} key="description" />
      )}
      {!!keywords && <meta name="keywords" content={keywords} key="keywords" />}
      <meta name="twitter:site" content="@thrivent" key="twitter:site" />

      {!!title && <meta property="og:title" content={title} key="og:title" />}
      {!!url && <meta property="og:url" content={url} key="og:url" />}
      {!!url && <link rel="canonical" href={url} />}
      {!!siteName && (
        <meta property="og:site_name" content={siteName} key="og:site_name" />
      )}
      <meta property="og:type" content="website" key="og:type" />
      {/* Note: these can't be called as <ImageMetadata />, <SchemaMarkup />
          because it nests "too deep" for the <Head> to parse*/}
      {!!metadata && SchemaMarkupScript({ metadata })}
      {ImageMetadataTags({ image })}
      <meta
        name="format-detection"
        content="telephone=no, date=no, email=no, address=no"
      />
    </Head>
  );
};
